<template>
    <!-- <div class="protected" v-if="loginSuccess">
        <h1>
            <b-badge variant="success">보안 사이트에 대한 액세스가 허용되었습니다</b-badge>
        </h1>
        <h5>로그인 성공!</h5>
    </div> -->
    
    <section class="bg-account-pages vh-100 d-flex align-items-center bg-center position-relative">
        <div class="container" id="app">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-5">
                    <div class="bg-white shadow">
                        <div class="p-4">
                            <div class="text-center mt-3">
                                <a href="/">
                                    <img src="../../../images/logo-dark.png" alt="" class="logo-dark" height="30" />
                                </a>
                                <p class="title-signup">내정보</p>
                            </div>
                            <div class="p-3">

                                    
                                <div class="mb-4">
                                    <label for="firstname" class="form-label">이메일</label>
                                    <input id="email" v-model="email" type="email" name="email"
                                        placeholder="이메일"  class="form-control" disabled/>
                                </div>
                                
                                <div class="mb-4">
                                    <label for="userpassword" class="form-label">마케팅 수신동의</label>
                                    <br>
                                    <input class="form-check-input" type="checkbox" @change="agreeMarket"
                                        v-model="marketing"  value="checkSub4">
                                    <label class="form-check-label" >
                                        이벤트, 프로모션 알림 메일 수신
                                    </label>
                                </div>
                                <div class="mt-4 mb-0 text-center" v-if="changePw === 'email'">
                                    <router-link to="/user/resetpw" class="text-dark">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock icon-xs icon me-1"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>비밀번호 변경
                                    </router-link>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                    <div class="text-center mt-4">
                        
                        <a @click="quit" style="cursor: pointer" class="font-weight-semibold text-primary">
                            회원탈퇴
                        </a>
                    </div>
                </div>
                <!-- end col -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>

</template>

<script>
import Swal from '../../../js/sweetalert2.min.js';
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default {
    data(){
        return {
            level:"",
            latest:"",
            next:"",
            email: "",
            checkSub4: "",
            changePw:"",
            membership:"",
            marketing: ""
        }
    },
    beforeMount(){
        this.getMyInfo();
    },
    methods: {
        invalidSession: function(error){
            Swal.close();
            if(error && error.response && error.response.status && error.response.status == 401){
                swal('세션이 만료되었습니다. 다시 로그인 해주세요.').then(() => {
                    this.$router.push('/signin')
                });
            } else {
                swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
            }
        },
        getMyInfo: function(e){
            
            Swal.showLoading();
            axios.get("/user/userInfo")
            
            .then(response => {  
                Swal.close();
                if(response.status == 200){
                    if(response.data.email){
                        
                        this.email = response.data.email;
                        this.marketing = response.data.marketing;

                        this.level = response.data.level;
                        this.latest = response.data.latest;
                        this.next = response.data.next;
                        this.changePw = response.data.idtype;
                        this.membership = response.data.membership
                    } else {
                        swal("세션이 만료되었습니다.\n다시 로그인 해주세요.",).then(() => {
                            this.$router.push('/signin')
                        });
                    }
                    

                } else {
                    swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
                }
            
            }).catch(error => {
                this.invalidSession(error)
            });
        },

        agreeMarket: function(){
            
            
            var form = new FormData();
            form.append('marketing', this.marketing);
            axios.post("/user/marketing", form)            
            .then(response => {  
                if(response.status != 200){
                    swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
                }   
            }).catch(error => {
                this.invalidSession(error) 
            });
        },
        cancel: function (){
            
            swal({
                    title: "정말로 멤버십을 해지하시겠습니까?",
                    text: "해지한 이후에도 잔여기간동안 멤버십 혜택이 유지됩니다.",
                    icon: "warning",
                    buttons: ["아니오", "네. 해지하겠습니다."],
                    dangerMode: true,
                })
                .then((willDelete) => {
                if (willDelete) {
                    // 해지 절차 
                    
                    
                    this.loginSuccess = false;
                    Swal.showLoading();
                    axios.post("/user/cancel")
                    
                    .then(response => {  
                        Swal.close();
                        if(response.status == 200){
                            var msg;
                            var code = response.data.code;
                            

                            swal("멤버십이 해지되었습니다.", {
                                icon: "success",
                            }).then(() => {
                                this.$router.go();
                            });
                            
                            
                        } else {
                            swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {icon: "info"})
                        }
                    
                    }).catch(error => {
                        this.invalidSession(error)
                    });

                }
                
            });
        },
        quit: function (){
            
            swal({
                    title: "정말로 탈퇴하시겠습니까?",
                    text: "회원탈퇴 즉시 모든 회원정보는 삭제됩니다.",
                    icon: "warning",
                    buttons: ["아니오", "네. 탈퇴하겠습니다."],
                    dangerMode: true,
                })
                .then((willDelete) => {
                if (willDelete) {
                    // 탈퇴 절차 
                    
                    
                    this.loginSuccess = false;
                    Swal.showLoading();
                    axios.post("/user/quit")
                    
                    .then(response => {  
                        Swal.close();
                        if(response.status == 200){
                            var msg;
                            var code = response.data.code;
                            
                            if(code == 10){
                                swal("회원 탈퇴되었습니다.\n 마이파랑을 이용해주셔서 감사합니다.", {
                                    icon: "success",
                                }).then(() => {
                                    this.$router.go();
                                });
                            } else if(code == 20){

                            } else if(code == 30){
                                swal('아직 멤버십 회원입니다.\n 멤버십을 해지하시고 탈퇴신청해주세요.', {
                                    icon: "info",
                                }).then(() => {
                                    this.$router.push('/main/pc4?tab=membership')
                                });
                                
                            }
                            
                            
                        } else {
                            swal('서버에 문제가 발생했습니다. \n 관리자에게 문의해주세요.\n code -', {
                                buttons: false,
                                timer: 3000
                            });
                        }
                    
                    }).catch(error => {
                        this.invalidSession(error)
                    });

                }
                
            });
        }
    }
}
</script>
<style>
.swal-footer {
    text-align: center;
}

.bc-e9ecef{
    background-color: #e9ecef;
    opacity: 1;
    
}

.vb-m{
    display: table-cell;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: left; 
}

.vb{
    display: table-cell;
    font-weight: 600;
    letter-spacing: -.42px;
    text-align: left;
}


.info_membership{
    justify-content: space-between;
    display: flex; 
    border-bottom: 0.01px solid #C6C6C6;
}


</style>


// WEBPACK FOOTER //
// src/components/user/MyInfo.vue